import React from 'react'
import './TravellerRateCard.css';

const tempoData = [
  {
    id: 1,
    img: "https://www.delhitempotravellers.com/images/9seater.jpg",
    title: "9 Seater Traveller",
    capacity: "9+1D",
    rate: "₹22/km",
    driver: "₹500/day",
    plan: "1×1",
  },
  {
    id: 2,
    img: "https://www.delhitempotravellers.com/images/10-seater-tempo-traveller.webp",
    title: "12 Seater Traveller",
    capacity: "12+1D",
    rate: "₹25/km",
    driver: "₹600/day",
    plan: "2×1",
  },
  {
    id: 3,
    img: "https://www.delhitempotravellers.com/images/12seater.jpg",
    title: "15 Seater Traveller",
    capacity: "15+1D",
    rate: "₹28/km",
    driver: "₹700/day",
    plan: "2×1",
  },
  {
    id: 4,
    img: "https://www.delhitempotravellers.com/images/14seater.jpg",
    title: "20 Seater Traveller",
    capacity: "20+1D",
    rate: "₹30/km",
    driver: "₹800/day",
    plan: "2×2",
  },
    {
    id: 2,
    img: "https://www.delhitempotravellers.com/images/16seater.jpg",
    title: "12 Seater Traveller",
    capacity: "12+1D",
    rate: "₹25/km",
    driver: "₹600/day",
    plan: "2×1",
  },
    {
    id: 4,
    img: "https://www.delhitempotravellers.com/images/17-seater-tempo-traveller.webp",
    title: "20 Seater Traveller",
    capacity: "20+1D",
    rate: "₹30/km",
    driver: "₹800/day",
    plan: "2×2",
  },
    {
    id: 1,
    img: "https://www.delhitempotravellers.com/images/15-seater-tempo-traveller.webp",
    title: "9 Seater Traveller",
    capacity: "9+1D",
    rate: "₹22/km",
    driver: "₹500/day",
    plan: "1×1",
  },
    {
    id: 3,
    img: "https://www.delhitempotravellers.com/images/20-seater-tempo-traveller.webp",
    title: "15 Seater Traveller",
    capacity: "15+1D",
    rate: "₹28/km",
    driver: "₹700/day",
    plan: "2×1",
  },
];

const TravellerRateCard = () => {
  return (
    <div>
       <div className="hydTempoCard-wrapper">
      <h2 className="hydTempoCard-title">
        Tempo Traveller <span>Options</span>
      </h2>
      <p className="hydTempoCard-subtitle">
        Select from a range of comfortable tempo travellers to match your group
        size and travel style.
      </p>

      <div className="hydTempoCard-grid">
        {tempoData.map((item) => (
          <div className="hydTempoCard-card" key={item.id}>
            <img src={item.img} alt={item.title} className="hydTempoCard-img" />
            <div className="hydTempoCard-body">
              <h3>{item.title}</h3>
              <ul>
                <li><span>Seating Capacity:</span> {item.capacity}</li>
                <li><span>Rate per Km:</span> {item.rate}</li>
                <li><span>Driver Fees:</span> {item.driver}</li>
                <li><span>Seating Plan:</span> {item.plan}</li>
              </ul>
              <button className="hydTempoCard-btn">Book Now</button>
            </div>
          </div>
        ))}
      </div>
    </div>
    </div>
  )
}

export default TravellerRateCard
